<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('propReservationDetails.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="breadcrumb-item mx-2">
          <router-link to="/myreservations">
            {{$t('subscriptionPackages')}}
          </router-link>
        </li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="breadcrumb-item mx-1 almarai-bold" aria-current="page">
          {{$t('subscriptionPackage_Details')}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7">
        <errorAlert
          v-if="hasError"
          :alertMessage="message"
          :errorNumber="errorNumber"
        />
      </div>
    </div>
    <div v-if="isLoading" class="row justify-content-center">
      <div class="col-12 col-md-8 text-center">
        <mainloader />
      </div>
    </div>
    <div v-if="!isLoading && hasLocation" class="row">
      <div class="col-12">
        <div class="row py-3 justify-content-center">
          <div class="col-12 col-md-7 homeMaintenance">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5>{{$t('homeMaintenance')}}</h5>
                  </div>
                  <div class="col-auto packagePrice">
                    <span>{{row.price}}</span>
                    <span class="mx-1">{{$t('currency')}}</span>
                    <span>{{$t('annually')}}</span>
                  </div>
                </div>
                <div class="title">{{row.description}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-7">
            <div class="card target">
              <div class="card-body">
                <div class="almarai-bold">{{$t('target')}}</div>
                <div class="row p-2">
                  <div class="col-auto">
                    <img src="/assets/images/icons/user.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('homeowners')}}</span>
                  </div>
                  <div class="col-auto mx-2">
                    <img src="/assets/images/icons/home.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('apartmentOwners')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-7">
            <div class="card featuresIncluded">
              <div class="card-body">
                <div class="almarai-bold">{{$t('featuresIncluded')}}</div>
                <div class="row features">
                  <div class="col-12 preLine" v-for="(val, indx) in row.features" :key="indx">
                    <span>
                      <img src="/assets/images/icons/tick-circle.png" class="w-24"  alt="">
                    </span>
                    <span class="mx-2">{{val}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row justify-content-center pt-3">
          <div class="col-12 col-md-7 smartControlPanel">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5>{{$t('smartControlPanel')}}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-7">
            <div class="card featuresIncluded">
              <div class="card-body">
                <div class="almarai-bold">{{$t('termsConditions')}}</div>
                <div class="row features">
                  <div class="col-12 preLine">
                    {{row.terms}} .
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-5 btn-green" @click.prevent="paymentFN">
            <div>{{$t('subscribeNow')}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="row justify-content-center">
            <div class="col-12">
              <errorAlert
                v-if="hasError"
                :alertMessage="message"
                :errorNumber="errorNumber"
              />
            </div>
          </div>
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="price">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{price}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioSelected" id="visa">
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                        <div class="bankCard">{{$t('wallet.bankCard')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioSelected" id="radioDefault1">
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                        <div class="bankCard">{{$t('wallet.appWallet')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-4 justify-content-center">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-10 text-center">
                <button @click.prevent="payrenewpackage" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:popup wallet balance -->
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row btn-closed">
              <div class="col-auto mouse-hand" @click.prevent="closeForm" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <h6 class="modal-title text-center almarai-bold">{{$t('walletPaymentConfirmation')}}</h6>
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{price}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{totalPrice}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-6 text-center" @click.prevent="createSubscribe">
                <div class="btn-black">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet" @click="closePopupCharge">
            <!-- <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button> -->
            <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-10 col-md-8">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->
    <successForm :messageSuccess='messageText' />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SuccessForm from '@/components/SuccessForm.vue';
export default {
  name: "detailsMaintenance",
  data(){
    return{
      packageID: this.$route.query.packageID,
      isLoading: true,
      hasError: false,
      message: '',
      errorNumber: null,
      row: {},
      price: null,
      totalPrice: "",
      paymentGate: "",
      latitude: 24.7136,
      longitude: 46.6753,
      messageText: this.$t('messageTex'),
      userLang: 'ar',
      hasLocation: false,
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER','USER_WALLET_BALANCE']),
  },
  components: {
    SuccessForm,
  },

  methods: {
    getPackageDetails(){
      this.$http.get('/api/mPackages/retrieve/'+this.packageID).then(res => {
        this.row = res.data.row;
        this.price = res.data.row.price;
        this.getLocation().then(locationData => {
          this.latitude = locationData.latitude;
          this.longitude = locationData.longitude;
          this.hasLocation = true;
        }).catch(() => {
          this.errorNumber = 0;
          this.message = 'يجب السماح لنا بالوصول لاحداثيات موقعك حتى تتمكن من الاشتراك';
          this.hasError = true;
        });
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        // this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    // activeSubscription(){
    //   this.$http.get('/api/mPackages/myActive').then(res => {
    //     // console.log(res);
    //   }).catch(err => {
    //     this.isLoading = false;
    //     [this.message, this.errorNumber] = this.$globalError(err, true);
    //     this.hasError = true;
    //     window.scrollTo({top:0, behavior: 'smooth'});
    //   })
    // },

    createSubscribe(){
      this.$http.post('/api/mPackages/subscribe',{
        paymentGate: this.paymentGate,
        packageId: this.packageID,
        latitude: this.latitude,
        longitude: this.longitude,
      }).then(res => {
        // console.log(res);
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('popup_WalletBalance').style.display = 'none';
          }
          document.getElementById('formSuccess').style.display = 'block';
        } 
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    // get current user loaction
    getLocation() {
      return new Promise((resolved, rejected) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolved({
                longitude: position.coords.longitude,
                latitude: position.coords.latitude,
              });
            },
            (err) => {
              rejected({ status: "failed" });
            }
          );
        } else {
          rejected({ status: "failed" });
        }
      });
    },

    payrenewpackage(){
      if(this.paymentGate == 'online'){
        this.createSubscribe();
      }else{
        this.WalletDetails();
      }
    },
    
    WalletDetails(){
      document.getElementById('closeModal').click();
      if(this.price > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else {
        this.totalPrice = this.USER_WALLET_BALANCE - this.price;
        document.getElementById('popup_WalletBalance').style.display = 'block';
      }
    },

    paymentFN(){
      document.getElementById('selectPayment').click();
    },

    closeForm(){
      document.getElementById('popup_WalletBalance').style.display = 'none';
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    }
  },
  created(){
    this.getPackageDetails();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>